module.exports = {
  "skid": {
    "alignItems": "stretch"
  },
  "border": {
    "borderBottomWidth": "1",
    "borderBottomColor": "#dddddd"
  },
  "dof-skid": {
    "flexDirection": "row",
    "backgroundColor": "#ffffff",
    "alignItems": "center"
  },
  "swipe-action-right": {
    "flexDirection": "row",
    "alignItems": "center"
  },
  "swipe-action-center": {
    "width": "750"
  },
  "swipe-action-child": {
    "width": "160",
    "backgroundColor": "#dddddd",
    "display": "flex",
    "alignItems": "stretch"
  },
  "swipe-action-text": {
    "fontFamily": "PingFangSC-Medium",
    "fontSize": "32",
    "color": "#ffffff",
    "letterSpacing": 0,
    "textAlign": "center"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-dd65dfac!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-swipe-list/index.vue
// module id = 551
// module chunks = 0 1